<template>
    <div class="cz2__model-preview__360">
        <button
            @click.prevent="rotatePreview(90)"
            aria-label="Rotate clockwise"
            class="cz2__model-preview__rotate cz2__model-preview__rotate-left-wrapper"
        >
            <!-- eslint-disable max-len, vue/max-len -->
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="26"
                xmlns:v="https://vecta.io/nano"
                viewbox="-3 -3 20 26"
                class="cz2__model-preview__rotate-left"
            >
                <path
                    d="M3.567 20c-.749 0-1.491-.289-2.054-.868a2.79 2.79 0 0 1 .09-3.969L7.06 9.999 1.604 4.835a2.79 2.79 0 0 1-.09-3.969 2.86 2.86 0 0 1 4.01-.089l7.6 7.189A2.78 2.78 0 0 1 14 9.999c0 .764-.315 1.499-.877 2.033l-7.6 7.189A2.8 2.8 0 0 1 3.567 20z"
                />
            </svg>
        </button>

        <img
            src="../assets/icons/360-icon.svg"
            alt="Rotate 360 degrees"
            class="cz2__model-preview__360--icon"
        >

        <button
            @click.prevent="rotatePreview(-90)"
            aria-label="Rotate counter-clockwise"
            class="cz2__model-preview__rotate cz2__model-preview__rotate-right-wrapper"
        >
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="26"
                xmlns:v="https://vecta.io/nano"
                viewbox="-3 -3 20 26"
                class="cz2__model-preview__rotate-right"
            >
                <path
                    d="M3.567 20c-.749 0-1.491-.289-2.054-.868a2.79 2.79 0 0 1 .09-3.969L7.06 9.999 1.604 4.835a2.79 2.79 0 0 1-.09-3.969 2.86 2.86 0 0 1 4.01-.089l7.6 7.189A2.78 2.78 0 0 1 14 9.999c0 .764-.315 1.499-.877 2.033l-7.6 7.189A2.8 2.8 0 0 1 3.567 20z"
                />
            </svg>
        </button>
    </div>
</template>

<style lang="scss">
    @use 'sass:math';
    @import "../style/variables.scss";

    #cz2.cz2 {
        .cz2__model-preview__360 {
            align-self: center;
            display: flex;
            align-items: center;
            gap: 50px;

            .cz2__model-preview__rotate {
                width: 44px;
                height: 44px;
                display: flex;
                justify-content: center;
                align-items: center;

                &:focus {
                    outline: none;

                    svg {
                        stroke: white;
                        stroke-width: 2;
                    }
                }
            }

            .cz2__model-preview__rotate-left {
                transform: scaleX(-1);
            }
        }

        .cz2__model-preview__360--icon {
            flex: none;
            width: 70px;
            height: 38px;
        }
    }

    #cz2.cz2.cz2__is-kiosk {
        .cz2__model-preview__360 {
            gap:0;
        }
    }

    #cz2.cz2.cz2__is-sb {
        .cz2__model-preview__360 {
            background-color: transparent;
            background-image: url(../assets/images/branded/sb-final/SB-Background_360.webp);
            background-size: 100% 100%;
            background-repeat: no-repeat;
            width: 178px;
            gap: 20px;
        }

        .cz2__model-preview__360--icon {
            width: auto;
            height: 30px;
        }

        .cz2__model-preview__rotate {
            svg {
                display: none;
            }
            background-image: url(../assets/images/branded/sb-final/SB-Chevron_360.webp);
            background-repeat: no-repeat;
            background-position: center;
            background-size: 40% 40%;
            margin-top: -2px;

            &:focus {
                outline: none;

                background-image: url(../assets/images/branded/sb-final/SB-Chevron_360.webp);
                background-repeat: no-repeat;
                background-position: center;
            }
        }
        .cz2__model-preview__rotate-right-wrapper {
            transform: rotate(180deg);
        }
    }

</style>

<script>
    import chevron from '../assets/icons/chevron.svg';

    export default {
        data() {
            return {
                chevronIcon: chevron,
            };
        },

        methods: {
            rotatePreview(degrees) {
                this.$store.dispatch('setPreviewRotation', degrees);

                this.emitter.$emit('previewRotation');
            },

            handleRotationHotkeys(event) {
                if (event.key === 'ArrowRight') {
                    event.preventDefault();
                    this.rotatePreview(-90);
                }

                if (event.key === 'ArrowLeft') {
                    event.preventDefault();
                    this.rotatePreview(90);
                }
            },
        },

        computed: {
            isSpellingBee() {
                return this.$store.state.isSpellingBee;
            },

            inspectModalShown() {
                return this.$store.state.inspectModalShown;
            },
        },

        mounted() {
            window.addEventListener('keydown', this.handleRotationHotkeys);
        },

        beforeDestroy() {
            window.removeEventListener('keydown', this.handleRotationHotkeys);
        },
    };
</script>
